// Tipos de autenticação - Dashboard Comercial

export type UserRole =
  | 'admin'
  | 'gestor'
  | 'gerente'
  | 'corretor'
  | 'vendedor'
  | 'gestor_rh'
  | 'gestor_cr'

export interface User {
  id: string
  nome: string
  email: string
  perfil: UserRole
  ativo: boolean
  imobiliaria_id?: number | null
  id_corretor?: number | null
  modulos_acesso?: string[]
  avatar?: string
}

// Roles que têm acesso ao Dashboard Comercial
export const COMERCIAL_ROLES: UserRole[] = [
  'admin',
  'gestor',
  'gerente',
  'corretor',
  'vendedor',
]

// Verifica se usuário tem acesso ao módulo comercial
export function hasComercialAccess(user: User | null): boolean {
  if (!user) return false

  // Verifica pelo perfil
  if (COMERCIAL_ROLES.includes(user.perfil)) return true

  // Verifica pelos módulos de acesso
  if (user.modulos_acesso?.includes('comercial')) return true

  return false
}

// Verifica se usuário é admin
export function isAdmin(user: User | null): boolean {
  return user?.perfil === 'admin'
}

// Verifica se usuário é gestor ou superior
export function isGestorOrAbove(user: User | null): boolean {
  if (!user) return false
  return ['admin', 'gestor', 'gerente'].includes(user.perfil)
}
